import { Currency } from '@/core/currency/interfaces';

const RON: Currency = {
    name: 'Romanian Leu',
    demonym: 'Romanian',
    majorSingle: 'Leu',
    majorPlural: 'Lei',
    codeNumeric: '946',
    symbol: 'L',
    symbolNative: 'L',
    minorSingle: 'Ban',
    minorPlural: 'Bani',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'RON',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default RON;
